import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./index.scss";
const Introduction = ({ about, nep }) => {
  const { slug } = useParams();
  useEffect(() => {
    const AddClassInh3 = document.querySelectorAll("h4");
    // console.log("AddClassInh3", AddClassInh3);
    AddClassInh3[0].setAttribute("class", "mission");
    AddClassInh3[1].setAttribute("class", "vission");
  }, [slug]);

  return (
    <>
      <div className="MainIntro">
        <div className="wrapper">
          <div className="MainIntroCon">
            <div className="IntroText">
              <h2 className="section-label">{nep ? "हाम्रो बारेमा" : "About Us"} </h2>
              <h1>{about.title}</h1>
              <div
                className="DengerusHTML"
                dangerouslySetInnerHTML={{ __html: about.description }}
              ></div>
            </div>
            <div className="IntroImages">
               <img src={about.featured_img} alt={about.file_alt || about.cover_alt || about.title} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Introduction;
